/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

import Asterisk_L from './S2_AsteriskSize200.svg';
import Asterisk_M from './S2_AsteriskSize100.svg';
import Asterisk_XL from './S2_AsteriskSize300.svg';
import {SVGProps} from 'react';

export default function Asterisk(props: SVGProps<SVGSVGElement> & {size?: 'M' | 'L' | 'XL'}) {
  let {size = 'M', ...otherProps} = props;
  switch (size) {
    case 'M':
      return <Asterisk_M {...otherProps} />;
    case 'L':
      return <Asterisk_L {...otherProps} />;
    case 'XL':
      return <Asterisk_XL {...otherProps} />;
  }
}
